export default __webpack_public_path__ + "static/media/sample.c516e224.xlsx";